module.exports = __webpack_public_path__ + "static/media/people_black_24dp.f68e5632.svg";